import SubmissionForm from '../helpers/SubmissionForm'

export default class ContactForm {
    constructor(root) {
        this.root = root;
        this.form = this.root.querySelector('.js-contact-form');

        new SubmissionForm(this.root, 'contact-us', 'contact_us', {
            nonce: window.theme.nonces.contact_us
        });
    }
}
